import {Injectable} from '@angular/core';
import {GenericCrudService} from '../../../../../services/generic-crud.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {FormViewerComponent} from '../../../../../form-viewer/form-viewer.component';
import {Entity} from '../../../../../helpers/entity';
import {InvoicePosition} from '../../../../../../data-generator/services/invoice-position';

@Injectable()
export class SubAssignmentAutocompleteHandlerService {

  public constructor(
    private genericCrudService: GenericCrudService,
    private masterComponent?: FormViewerComponent,
    private invoicePosition?: InvoicePosition
  ) {

  }

  public getData(query: string): Observable<any[]> {
    const route = `phoenix/subassignments/offset/0/limit/30/orderby/id/asc?search=${query}`,
      requestParams = {clause: 'orWhere', embedded: '' + 'assignment'};

    if (this.masterComponent.entity) {
      const customer = Entity.getValue(this.masterComponent.entity, 'customer') || Entity.getValueInEmbedded(this.masterComponent.entity, 'customer');
      if (customer && (this.invoicePosition && this.invoicePosition.leasedEmployee && typeof this.invoicePosition.leasedEmployee.id !== 'undefined')) {
        requestParams['assignment.leasedEmployee'] = this.invoicePosition.leasedEmployee.id;
        requestParams['assignment.customer'] = customer;
      } else if (customer) {
        requestParams['assignment.customer'] = customer;
      }
    }

    return this.genericCrudService.getEntities(route, '', requestParams)
      .pipe(map((paginated: {data: any[]}) => {
        const data = paginated.data;

        for (const subAssignment of data) {
          subAssignment.label = subAssignment.subAssignmentNumber;
        }

        return data;
      }));
  }
}
